export default __webpack_public_path__ + "static/media/14473_Atrium_E1_Insel1_1_roteTafel_1000x2430mm_RZ.8827f94e.pdf";